<template>
  <div>
    <div v-if="newsLinks.length > 0">
      <table class="custom-table table-hover">
        <thead>
          <tr>
            <th scope="col">News</th>
            <th scope="col">Description</th>
            <th scope="col">Source</th>
            <th scope="col">Publish Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in newsLinks" :key="n.newsId" @click="open(n.url)">
            <td>
              {{n.name}}
            </td>
            <td class="data align-center">
              {{n.description}}
            </td>
            <td class="data align-center">
              {{n.source}}
            </td>
            <td class="data align-center"> 
              {{$formatter.displayDate(n.date)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      Nothing to report
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newsLinks: { type: Array, default: () => [] }
  },
  data() {
    return {
      viewingNewsLink: null
    }
  },
  methods: {
    open(url) {
      window.open(url, '_blank');
    }    
  }
}
</script>